export default __webpack_public_path__ + "static/media/planet-2.114cdca2.svg";